import api from "./api";

export const create_printer = async(payload) =>{

    console.log("Payload at Printer Create => ", payload)
    
    try{
        const response = await api.post('/print/create_printer',payload);
        return response
    }
    catch(error){
        throw new Error(error)
    }
}


export const get_printers = async() =>{
    try{
        const response = await api.get('/print/get_printers');
        return response
    }
    catch(error){
        throw new Error(error)
    }
}

export const edit_printer = async(id,payload) =>{
    try{
        const response = await api.put(`/print/edit_printer/${id}`,payload);
        return response
    }
    catch(error){
        throw new Error(error)
    }
}


export const get_kitchen_invoice = async(order_id) =>{
    try{
        const response = await api.get(`/print/get_kitchen_invoice_printer/${order_id}`, {
            responseType: 'blob'
        });
        return response
    }
    catch(error){
        throw new Error(error)
    }
}


export const get_bill_invoice = async(order_id) =>{
    try{
        const response = await api.get(`/print/get_invoice_print/${order_id}`, {
            responseType: 'blob'
        });
        return response
    }
    catch(error){
        throw new Error(error)
    }
}




// export default delete_printer = async(id) =>{
//     try{
//         const response = await api.delete(`/print/delete_printer/${id}`);
//         return response
//     }
//     catch(error){
//         throw new Error(error)
//     }
// }

